import { StyleSheet } from 'react-native'
import { Colors, Fonts, Metrics } from 'APP/Themes'

export default StyleSheet.create({
  scrollViewContentContainer: {
    paddingTop: Metrics.baseMargin,
    paddingBottom: Metrics.bottomSpace + Metrics.baseMargin,
  },
  spacing: {
    marginBottom: Metrics.baseMargin,
  },
  limitationText: {
    ...Fonts.style.subheader,
    color: Colors.text,
    marginVertical: Metrics.baseMargin,
    textAlign: 'center',
  },
  loading: {
    flex: 1,
  },
  retry: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  retryTitle: {
    ...Fonts.style.h3,
    color: Colors.text,
    marginTop: Metrics.baseMargin * 2,
    marginBottom: Metrics.baseMargin,
  },
  retryCopy: {
    ...Fonts.style.bodyLarge,
    color: Colors.text,
  },
  retryCta: {
    marginTop: Metrics.baseMargin * 2,
    minWidth: 140,
  },
})
